import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import client from "../../api/client";

export default function AdminCohortCoursesPage() {
  const { cohortId } = useParams();
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [cohortName, setCohortName] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("nd-rest-tkn");
    if (token) client.defaults.headers.Authorization = `Bearer ${token}`;
    client.get("/admin/cohorts")
      .then(res => {
        const found = res.data.find(c => String(c.id) === String(cohortId));
        if (found) setCohortName(found.name);
      });
    client.get(`/admin/cohorts/${cohortId}/courses`)
      .then(res => setCourses(res.data))
      .catch(() => toast.error("Failed to load courses."))
      .finally(() => setLoading(false));
  }, [cohortId]);

  return (
    <div className="p-6 md:p-8 max-w-5xl mx-auto">
      <button onClick={() => navigate("/dashboard/admin/cohorts")}
        className="text-sm text-gray-400 hover:text-gray-700 transition-colors mb-1 block">
        ← Cohorts
      </button>
      <div className="mb-6">
        <h1 className="text-xl font-bold text-gray-900">{cohortName || "Cohort Courses"}</h1>
        <p className="text-sm text-gray-500 mt-0.5">
          {courses.length} course{courses.length !== 1 ? "s" : ""} — click a course to see its classes and students
        </p>
      </div>

      {loading ? (
        <div className="space-y-3">{[1, 2, 3].map(i => <div key={i} className="h-16 bg-white rounded-2xl border border-gray-100 animate-pulse" />)}</div>
      ) : courses.length === 0 ? (
        <div className="p-16 text-center bg-white rounded-2xl border border-gray-100">
          <p className="text-4xl mb-3">📚</p>
          <p className="text-sm font-medium text-gray-600">No courses linked to this cohort</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden divide-y divide-gray-100">
          {courses.map(course => (
            <button
              key={course.id}
              onClick={() => navigate(`/dashboard/admin/courses/${course.id}/cohorts/${cohortId}`)}
              className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left"
            >
              {course.image_url ? (
                <img src={course.image_url} alt="" className="w-12 h-12 rounded-xl object-cover flex-shrink-0 bg-gray-100" />
              ) : (
                <div className="w-12 h-12 rounded-xl bg-[#294a93]/10 flex items-center justify-center flex-shrink-0">
                  <span className="text-[#294a93] text-lg font-bold">{course.title[0]}</span>
                </div>
              )}
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-gray-800 text-sm truncate">{course.title}</p>
                <div className="flex items-center gap-3 mt-1">
                  <span className="text-xs text-gray-400">{course.schedules_count ?? 0} class{(course.schedules_count ?? 0) !== 1 ? "es" : ""}</span>
                  <span className="text-xs text-gray-400">{course.subscribers_count ?? 0} enrolled</span>
                  {course.type && (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-[#294a93]/10 text-[#294a93] font-semibold capitalize">{course.type}</span>
                  )}
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
